export default "__VITE_ASSET__ByRERC5a__"